import { ContactDialog } from '@/components/marketing/contact-dialog';
import { Button } from '@/components/ui/button';
import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/security')({
    component: SecurityPage,
});

function SecurityPage() {
    return (
        <div className="min-h-screen bg-emerald-50 text-emerald-950">
            <header className="border-b border-emerald-100 bg-white/80">
                <div className="mx-auto flex w-full max-w-5xl items-center justify-between px-4 py-5">
                    <Link to="/" className="flex items-center gap-3">
                        <img
                            src="https://res.cloudinary.com/flannery38/image/upload/v1771973120/stockwright/logo.svg"
                            alt="Stockwright"
                            className="h-6"
                        />
                    </Link>
                    <div className="flex items-center gap-3">
                        <Link
                            to="/faq"
                            className="text-sm text-emerald-800/80 hover:text-emerald-900"
                        >
                            FAQ
                        </Link>
                        <Link
                            to="/terms"
                            className="text-sm text-emerald-800/80 hover:text-emerald-900"
                        >
                            Terms
                        </Link>
                        <Button asChild className="bg-emerald-700 text-white">
                            <Link to="/auth" search={{ mode: 'signup' }}>
                                Start Free Trial
                            </Link>
                        </Button>
                    </div>
                </div>
            </header>

            <main className="mx-auto w-full max-w-5xl px-4 py-12">
                <div className="mb-10">
                    <p className="text-xs font-semibold uppercase tracking-wide text-emerald-600/80">
                        Security
                    </p>
                    <h1 className="mt-2 text-3xl font-semibold">
                        How we protect your data
                    </h1>
                    <p className="mt-3 max-w-2xl text-sm text-emerald-900/70">
                        Stockwright is built with modern security practices and
                        trusted providers.
                    </p>
                </div>

                <div className="grid gap-6">
                    <section className="rounded-2xl border border-emerald-100 bg-white p-6">
                        <h2 className="text-lg font-semibold">Payments</h2>
                        <p className="mt-2 text-sm text-emerald-900/70">
                            Payments are processed by Stripe. We do not store
                            raw card data on our servers.
                        </p>
                    </section>
                    <section className="rounded-2xl border border-emerald-100 bg-white p-6">
                        <h2 className="text-lg font-semibold">
                            Authentication
                        </h2>
                        <p className="mt-2 text-sm text-emerald-900/70">
                            Accounts are secured using Supabase authentication.
                            Sessions are encrypted and expire automatically.
                        </p>
                    </section>
                    <section className="rounded-2xl border border-emerald-100 bg-white p-6">
                        <h2 className="text-lg font-semibold">
                            Data protection
                        </h2>
                        <p className="mt-2 text-sm text-emerald-900/70">
                            Data is stored in managed infrastructure with
                            access controls and regular backups.
                        </p>
                    </section>
                    <section className="rounded-2xl border border-emerald-100 bg-white p-6">
                        <h2 className="text-lg font-semibold">
                            Need to report an issue?
                        </h2>
                        <p className="mt-2 text-sm text-emerald-900/70">
                            Contact us and we will investigate quickly.
                        </p>
                        <div className="mt-4">
                            <ContactDialog />
                        </div>
                    </section>
                </div>
            </main>
        </div>
    );
}
